import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "./Nav.css";
import ReactGA from 'react-ga4';
import { useNavigate } from "react-router";
import { useUserAuth } from "../../User/UserAuthContext/UserAuthContext";
import logo from "../../assests/logo.jpeg";
// import Avtar from "../../components/Images/avatar-placeholder.jpg";
import { useState } from "react";
import { BASE_URL } from "../../api";
import { FaBars, FaTimes } from "react-icons/fa";

function Nav2() {
  const { handleLogout, user } = useUserAuth();
  const [profileData, setProfileData] = useState({ profile_pic: "" });

  const navigate = useNavigate();
  const [isActive, setIsActive] = useState(false);
  const handleLoginClick = () => {
    ReactGA.event({
      category: 'Navigation',
      action: 'Button Click',
      label: 'Register Player Link Clicked',
    });
  };

  const handleToggle = () => {
    setIsActive(!isActive);
  };
  const Logout = async () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    try {
      await handleLogout();
      navigate("/");
    } catch (error) {
      console.log(error.message);
    }
  };

  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);

  const closeMenu = () => setClick(false);

  // Student detail data Api-----------------
  const fetchProfileData = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Token not found");
      }

      const response = await fetch(`${BASE_URL}users/profile_me/`, {
        method: "GET",
        headers: {
          Authorization: `Token ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      setProfileData(data.data);

      // console.log(data.data); // log the fetched data
    } catch (error) {
      // console.error(error);
    }
  };

  // useEffect(() => {
  //   fetchProfileData();
  // }, []);
  useEffect(() => {
    if (user) {
      fetchProfileData();
    }
  }, [user]);

  // -------------------NOTIFICATIONS-------------------------
  // -------------------NOTIFICATIONS-------------------------
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showNotifications, setShowNotifications] = useState(false);
  const dropdownRef = useRef();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      fetch(`${BASE_URL}notifications/list/`, {
        headers: {
          Authorization: `Token ${token}`,
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          setNotifications(data.data.reverse());
          setLoading(false);
          // console.log(data); // log the fetched data
        })
        .catch((error) => console.error(error));
    }
  }, []);

  const handleShowNotifications = () => {
    setShowNotifications(!showNotifications);
  };

  // Add event listener to detect clicks outside of notification dropdown
  useEffect(() => {
    const handleOutsideClick = (event) => {
      // Check if target of click event is inside the notification dropdown
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowNotifications(false);
      }
    };

    document.addEventListener("click", handleOutsideClick);

    // Cleanup function to remove event listener
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [showNotifications]);

  
  const handleRegisterPlayerClick = () => {
    // Track the button click event
    ReactGA.event({
      category: 'Navigation',
      action: 'Click Register Player',
      label: 'Register Player Link Clicked',
    });
    closeMenu();
  
    
  };

  return (
    <div className="mainNav2-bg">
      <div className="Logo">
        <Link to="/">
          <img src={logo} alt="logo" className="logo-image2" />
        </Link>
      </div>
      {/*-----------Hamburger-Menu-Icons-------- */}
      <div className="hamburger" onClick={handleClick}>
        {click ? (
          <FaTimes size={30} style={{ color: "black" }} />
        ) : (
          <FaBars size={30} style={{ color: "black" }} />
        )}
      </div>
      <ul className={click ? "nav-menu active" : "nav-menu"}>
        <li className="nav-item">
          <Link to="/" onClick={closeMenu}>
            Home
          </Link>
        </li>
        <li className="nav-item">
          <Link to="/isbc" onClick={closeMenu}>
            ISBC
          </Link>
        </li>
        <li className="nav-item">
          <Link to="/camps" onClick={closeMenu}>
            Camps
          </Link>
        </li>
        <li className="nav-item">
          <Link to="/about-us" onClick={closeMenu}>
            About Us
          </Link>
        </li>{" "}
        {/* Register-Player-Conditional-Render */}
        {user ? (
          <>
            <li className="nav-item">
              <Link to="/register-form" onClick={handleRegisterPlayerClick}>
                Register Player
              </Link>
            </li>
            {/*--------------- Notifications--------------*/}
            <li className="nav-item">
              <div
                className="notification-icon"
                onClick={handleShowNotifications}
                ref={dropdownRef}
              >
                <i className="fa fa-bell"></i>
                {showNotifications && (
                  <div
                    className="notification-drop-down"
                    onMouseLeave={() => setShowNotifications(false)}
                  >
                    {loading ? (
                      <p>Loading...</p>
                    ) : (
                      <ul>
                        <p
                        
                          to={`/NotificationDetail/${notifications.id}`}
                          className="notifiactionitem"
                        >
                          {notifications.map((notification) => (
                            <li key={notification.id}   style={{
                              cursor: "pointer",
                              borderBottom: "1px solid gainsboro",
                            }}>
                              {notification.message}
                            </li>
                          ))}
                        </p>
                      </ul>
                    )}
                  </div>
                )}
              </div>
            </li>
          </>
        ) : (
          <></>
        )}
        {/* --------End----------Notifications-----------End-------------------- */}
        {/* -------------User-Login-Logout-Coditional-Rendering------------------ */}
        {user ? (
          <div className="LoginBtn">
            <div className="profileData"> {profileData?.full_name || ""}</div>
            <div className="dropdown">
              <div className="ProfilePictureBg">
                {profileData.profile_pic && (
                  <img
                    className="profileImg"
                    src={profileData.profile_pic}
                    alt=""
                  />
                )}
              </div>
              <div className="dropdown-content">
                <Link to="/edit_profile">Edit Profile</Link>
                <Link to="/registered-players" onClick={handleLoginClick}>Registered Players List</Link>
                <Link to="/register-form">Add New Player</Link>
                <Link to="/" onClick={Logout}>
                  Logout
                </Link>
              </div>
            </div>
          </div>
        ) : (
          <div className="LoginBtn">
            <Link className="LoginButton" onClick={handleLoginClick} to="/Login">
              Login
            </Link>
          </div>
        )}
      </ul>
    </div>
  );
}

export default Nav2;
